import DialogTitle from "@material-ui/core/DialogTitle";
export default DialogTitle;